// Original hand-drawn checkbox artwork (MemoNest). Wobbly square; checked adds a hand-drawn cross.
export function CheckboxGlyph({ checked, color }: { checked: boolean; color: string }) {
  return (
    <svg viewBox="0 0 40 40" className="nc-check-glyph" aria-hidden="true" focusable="false">
      <path
        d="M6.2 7.4 C13 6.1 22.6 5.6 33.4 6.6 C34.6 14.8 34.9 24.1 33.9 33.6 C24.7 34.5 15.3 34.7 6.6 34.1 C5.6 25.7 5.4 16.2 6.2 7.4 Z"
        fill="none"
        stroke={color}
        strokeWidth="3.4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      {checked && (
        <path d="M10.5 10.8 C17 17.2 23.6 24.1 29.8 30.2 M29.4 10.2 C22.9 16.9 16.6 23.6 10.6 30.4" fill="none" stroke={color} strokeWidth="3.6" strokeLinecap="round" />
      )}
    </svg>
  );
}
